import roadInfrastructure from "../assets/img/road_infrastructure.png";
import civilInfrastructure from "../assets/img/civil_infrastructure.png";
import stormWaterInfrastructure from "../assets/img/stormwater_infrastructure.png";
import openSpaceInfrastructure from "../assets/img/open_space_infrastructure.png";
import waterInfrastructure from "../assets/img/water_infrastructure.png";
import sewerInfrastructure from "../assets/img/sewer_infrastructure.png";
import buildingInfrastructure from "../assets/img/building_infrastructure.png";
import indexationImage from "../assets/img/indexation_infrastructure.png";

export const BaseUrl = () => {
  return "/";
};
export const AuthUrl = () => {
  return import.meta.env.PROD ? "https://auth.arc360.net.au" : "https://localhost:7000";
};

export const redirectUrl = import.meta.env.PROD ? `https://${window.location.host}/index.html` : `https://${window.location.host}/Login-OIDC`;

export const supportedModules = [
  { title: "Road Infrastructure", img: roadInfrastructure },
  { title: "Civil Infrastructure", img: civilInfrastructure },
  { title: "Stormwater Infrastructure", img: stormWaterInfrastructure },
  { title: "Open Space Infrastructure", img: openSpaceInfrastructure },
  { title: "Water Infrastructure", img: waterInfrastructure },
  { title: "Sewer Infrastructure", img: sewerInfrastructure },
  { title: "Building & Other Infrastructure", img: buildingInfrastructure },
  { title: "Indexation", img: indexationImage },
];

export const supportedMathFunction = [
  "Round(0)",
  "Ceil(0)",
  "Floor(0)",
  "Sqrt(0)",
  "Cbrt(0)",
  "Exp(0)",
  "Log(0)",
  "Abs(0)",
  "Sin(0)",
  "Cos(0)",
  "Tan(0)",
  "Power(1 , 2)",
  "Max(1 , 2)",
  "Min(1 , 2)",
  "Trend({4, 5, 6}, {1, 2, 3}, 4, 1)",
];

export const tenant = localStorage.getItem("a360-tenant") ?? "default";
